import React, { FC, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useAuthContext } from "common/contexts/AuthContext";
import { useOktaContext } from "common/contexts/OktaContext";

const AuthResponse: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { finalizeLogin } = useAuthContext();
  const { setIsInternalUser, isInternalUser } = useOktaContext();

  const queryParams = new URLSearchParams(location.search);
  const userType = queryParams.get("userType");
  const localeCode = queryParams.get("localeCode");

  useEffect(() => {
    const isInternal = userType?.toLowerCase() === "internal";
    // If Okta is already setup to the correct internal/external domain then go ahead and finalize the login process
    if (isInternal === isInternalUser) {
      const postAuthUrl = localStorage.getItem("postAuthUrl");
      if (postAuthUrl) {
        const localLogin = async () => {
          await finalizeLogin();
        };
        localLogin();

        history.push(postAuthUrl);
        localStorage.removeItem("postAuthUrl");
      } else {
        history.push("/");
      }
    } else {
      // Okta domain needs to be changed - change it and after it's changed in the context this useEffect will fire and login can complete
      setIsInternalUser(userType?.toLowerCase() === "internal");
      console.log("DELAYING LOGIN TO WAIT FOR OKTA INTERNAL/EXTERNAL CHANGE")
    }
    // Only want this useEffect to run on initial render and when isInternalUser changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInternalUser]);

  return (
    <div>
      userType = {userType}, localeCode = {localeCode}
    </div>
  );
};

export default AuthResponse;
